import { fmt } from '../utils/format';

// One KPI tile. `tone` picks the icon accent color.
// Tones: purple | blue | green | red | gray.
const TONE = {
  purple: { icon: 'text-purpleColor', bg: 'bg-purpleColor/10' },
  blue: { icon: 'text-darkBlueColor', bg: 'bg-darkBlueColor/10' },
  green: { icon: 'text-greenColor', bg: 'bg-greenColor/10' },
  red: { icon: 'text-redColor', bg: 'bg-redColor/10' },
  gray: { icon: 'text-darkGrayColor', bg: 'bg-lightGrayColor' },
};

export const KpiCard = ({ label, value, sub, icon: Icon, tone = 'purple' }) => {
  const t = TONE[tone] || TONE.purple;
  return (
    <div className="flex items-start gap-3 rounded-lg border border-gray-200 p-4 bg-white hover:shadow-sm transition-all duration-200">
      <div className={`flex items-center justify-center w-9 h-9 rounded ${t.bg} ${t.icon} flex-shrink-0`}>
        {Icon && <Icon size={18} />}
      </div>
      <div className="flex flex-col leading-tight min-w-0">
        <span className="text-[10px] uppercase tracking-wider text-darkGrayColor">
          {label}
        </span>
        <span className={`text-2xl font-semibold ${t.icon} leading-none mt-1`}>
          {typeof value === 'number' ? fmt(value) : value ?? '—'}
        </span>
        {sub && (
          <span className="text-[11px] text-darkGrayColor mt-1.5 truncate">
            {sub}
          </span>
        )}
      </div>
    </div>
  );
};

export const KpiCardSkeleton = () => (
  <div className="flex items-start gap-3 rounded-lg border border-gray-200 p-4 bg-white">
    <div className="w-9 h-9 rounded bg-lightGrayColor animate-pulse flex-shrink-0" />
    <div className="flex flex-col gap-2 flex-1">
      <div className="h-2.5 w-16 rounded bg-lightGrayColor animate-pulse" />
      <div className="h-6 w-24 rounded bg-lightGrayColor animate-pulse" />
      <div className="h-2 w-20 rounded bg-lightGrayColor animate-pulse" />
    </div>
  </div>
);
